<template>
  <div class="dashBoardPage mt20">
    <div class="kqf-card mg10 pd10 mt20" style="font-size:60px">
        欢迎使用
    </div>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import CounTarrow from "@/pages/dashboard/components/CounTarrow";
import {adminStatistics, getZh} from "../../request/api/finance/userpresent";

export default {
  components: {CounTarrow, countTo},
  data() {
    return {
      datas: {
        register_num: {
          total_r_num: 0,//总注册人数
          nowday_r_num: 0,//今日注册人数
          lastday_r_num: 0,//昨日注册人数
          bmonth_r_num: 0,//本月注册人数
          lastmoth_r_num: 0,//上月注册人数
        },
        order_num: {
          total_order_num: 0,//总订单数
          help_nowday_order_num:0,
          help_lastday_order_num:0,
          help_bmonth_order_num:0,
          help_lastmoth_order_num:0,
          kd_nowday_order_num:0,
          kd_lastday_order_num:0,
          kd_bmonth_order_num:0,
          kd_lastmoth_order_num:0,
          sh_nowday_order_num:0,
          sh_lastday_order_num:0,
          sh_bmonth_order_num:0,
          sh_lastmoth_order_num:0,
          sm_nowday_order_num:0,
          sm_lastday_order_num:0,
          sm_bmonth_order_num:0,
          sm_lastmoth_order_num:0,
        },
        money_num: {
          total_order_money: 0,//总成交金额
          nowday_order_money: 0,//今日成交金额
          lastday_order_money: 0,//昨日成交金额
          bmonth_order_money: 0,//本月成交金额
          lastmoth_order_money: 0//上月成交金额
        },
        bj_num: {
          nowday_bj: 0,
          lastday_bj: 0,
          by_bj: 0,
          sy_bj: 0,
        },
        cash_out_money: {
          total_cash_out: 0,//总提现
          nowday_cash_out: 0,//今日提现
          lastday_cash_out: 0,//昨日提现
          bmonth_cash_out: 0,//本月提现
          lastmoth_cash_out: 0,//上月提现
          not_cash_out: 0,   //未提现
          pending_cash_out: 0,     //待处理(待审核)
          pending_fk: 0     //待处理(待审核)
        },
        yq_num: {
          total_yq: 0,
          nowday_yq: 0,
          lastday_yq: 0,
          by_yq: 0,
          sy_yq: 0,
        },
      },
      // 饼状图
      chartSettings: {
        radius: [80, 120],

      },
      chartData: {
        columns: ["status", "num"],
        rows: [
          {status: "待收货", num: 0},
          {status: "待接手", num: 0},
          {status: "待质检", num: 0},
          {status: "重检", num: 0},
          {status: "已质检", num: 0},
          {status: "申请成交", num: 0},
          {status: "申请退货", num: 0},
          {status: "申请重检", num: 0},
        ],
      },
      chartDataSm: {
        columns: ["status", "num"],
        rows: [
          {status: "待接手", num: 0},
          {status: "待接洽", num: 0},

        ],
      },
      zh: {
        jt_order_num: 0,
        zt_order_num: 0,
        by_order_num: 0,
        sy_order_num: 0,
      },
      chartExtend: {
        legend: {
          show: true,
          bottom: "bottom",
        },
        //#007EFF #643CF9 #FFA200 #00FF9C #FF5400
        color: ["#ffd200", "#00ff4e", "#8400ff", "#ff5400", "#00ffd2","#0073ff","#ff0000","#ff5400"],
      },
      order_create_device:[],
      user_create_device:[],
    };
  },
  created() {
    // this.getList();
    // this.getZh();
  },
  methods: {
    getZh() {
      getZh({})
          .then((res) => {
            this.zh = res;
            this.order_create_device=res.order_create_device;
            this.user_create_device=res.user_create_device
          })
    },
    getList() {
      this.loading = true;
      adminStatistics({})
          .then((res) => {
            this.datas = res;
            this.chartData.rows = res.order_count.yj
            this.chartDataSm.rows = res.order_count.sm;
          })
          .catch(() => {
            this.loading = false;
          });
    },
  },
}
</script>

<style scoped lang="scss">
.dashBoardPage{
  height:calc(100vh - 116px);
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}

.data-analysis {
  margin-top: 20px;

  .data-analysis-l {
    flex: 1;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 20px 20px 40px 20px;

    .sjfx-item-box {
      &:nth-child(1){
        margin-top: 20px;
      }
      &:nth-child(2){
        margin-top: 40px;
      }
      //margin-top: 0px;
      display: flex;

      .flex-item {
        width: 90px;
        line-height: 90px;
      }

      .sjfx-item {
        flex: 1;

        p:nth-child(1) {
          font-size: 16px;
          color: #4D4F52;
        }

        p:nth-child(2) {
          font-size: 22px;
          font-weight: 600;
          color: #4D4F52;
          margin: 10px 0;
        }
      }
    }
  }


}

.order-count-tu {
  flex: 1;
  height: 400px;
  background: #FFFFFF;
  border-radius: 10px;
  padding: 20px;
}
.data-analysis-r {
  width: 300px;
  height: 400px;
  margin-right: 20px;
  background: #FFFFFF;
  border-radius: 10px;
  padding: 20px;

  .zhl-box {
    .zhl-box-item {
      margin-top: 40px;

      p:nth-child(1) {
        font-size: 16px;
        color: #4D4F52;
      }

      p:nth-child(2) {
        font-size: 22px;
        font-weight: 600;
        color: #4D4F52;
        margin: 10px 0;
      }
    }
  }
}
.order-count-btu {
  width: 500px;
  height: 400px;
  background: #FFFFFF;
  border-radius: 10px;
  padding: 20px;
  margin-left: 20px;
}

.count-num-content {
  flex: 1;
  margin-left: 20px;
  width: 80%;
  height: 224px;
  background: #FFFFFF;
  border-radius: 10px;
  padding: 20px;
  flex-wrap: wrap;

  .count-num-item {
    width: 25%;
    text-align: center;
    padding-top: 14px;

    .count-num-zi {
      font-size: 24px;
      font-weight: 400;
      color: #242527;
    }

    p {
      font-size: 16px;
      font-weight: 400;
      color: #55575B;
      margin-bottom: 8px;
    }
  }
}

.zc-card {
  width: 220px;
  height: 224px;
  background: #FFFFFF;
  border-radius: 10px;

  .zc-card-title {
    margin-top: 20px;
    color: #55575B;
    font-size: 14px;
  }

  .zc-card-num {
    margin-top: 8px;

    p {
      font-size: 24px;
      font-weight: 400;
      color: #242527;
    }
  }
}

</style>